import React from 'react'
import { Link, Element } from 'react-scroll';
import { Typography, Box } from '@mui/material'
import { styled } from '@mui/material/styles';

import Page from '../components/Page';

import Homebanner from '../components/home/Homebanner';
import HomeCompany from '../components/home/HomeCompany';
import HomeAbout from '../components/home/HomeAbout';
import HomeFeature from '../components/home/HomeFeature';
import HomeAboutContent from '../components/home/HomeAboutContent';
import HomeSubscription from '../components/home/HomeSubscription';
import HomeContactForm from '../components/home/HomeForm';
import HomeRequest from '../components/home/HomeRequest';
const RootStyle = styled(Page)({
  height: '100%'
});

const ContentStyle = styled('div')(({ theme }) => ({
  overflow: 'hidden',
  position: 'relative',
  backgroundColor: theme.palette.background.default
}));

export default function LandingPage() {
  return (
    <RootStyle title="Sparkle Time keeping" id="move_top">
    <Element name='homeSection' className='section'>
      <Homebanner/>
    </Element>
    <ContentStyle>
      <Element name='productSection' className='section'>
        <HomeAbout/>
      </Element>
      <Element name='featureSection' className='section'>
        <HomeFeature/>
      </Element>
      <Element>
        <HomeAboutContent/>
      </Element>
      <Element name='pricingSection' className='section'>
        <HomeSubscription/>
      </Element>
      <Element name='formSection' className='section'>
        <HomeContactForm/>
      </Element>
      <HomeRequest/>
      <Element> <HomeCompany/> </Element>
    </ContentStyle>
  </RootStyle>
  )
}
